import { render, staticRenderFns } from "./pageSearch.vue?vue&type=template&id=5ac634ce&scoped=true&"
import script from "./pageSearch.vue?vue&type=script&lang=js&"
export * from "./pageSearch.vue?vue&type=script&lang=js&"
import style0 from "./pageSearch.vue?vue&type=style&index=0&id=5ac634ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac634ce",
  null
  
)

export default component.exports